import { render, staticRenderFns } from "./PriceRequests.vue?vue&type=template&id=5bf736ac&scoped=true"
import script from "./PriceRequests.vue?vue&type=script&lang=js"
export * from "./PriceRequests.vue?vue&type=script&lang=js"
import style0 from "./PriceRequests.vue?vue&type=style&index=0&id=5bf736ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf736ac",
  null
  
)

export default component.exports